import {
  Directive,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
  effect,
} from '@angular/core';
import { UserDataService } from '../../core/services/user-data.service';
import { Program } from '../enums/program.enum';
import { Feature } from '../enums/feature.enum';

const FEATURE_BY_PROGRAM = {
  [Feature.LevelSystem]: new Set<Program>([
    Program.Guatemala,
    Program.Honduras,
    Program.Panama,
    Program.Costa_Rica,
    Program.Colombia,
    Program.Ecuador,
    Program.Venezuela,
  ]),
  [Feature.Certificates]: new Set<Program>([Program.Guatemala]),
  [Feature.SpecialCertificate]: new Set<Program>([Program.Honduras]),
  [Feature.RecomendationCarrousel]: new Set<Program>([
    Program.Guatemala,
    Program.Panama,
    Program.Costa_Rica,
    Program.Venezuela,
  ]),
  [Feature.Cart]: new Set<Program>([
    Program.Guatemala,
    Program.Panama,
    Program.Costa_Rica,
    Program.Venezuela,
  ]),
  [Feature.Whishlist]: new Set<Program>([
    Program.Guatemala,
    Program.Panama,
    Program.Costa_Rica,
    Program.Venezuela,
  ]),
  [Feature.MyOrders]: new Set<Program>([
    Program.Guatemala,
    Program.Panama,
    Program.Costa_Rica,
    Program.Chile,
    Program.Costa_Rica,
    Program.Guatemala,
    Program.Colombia,
    Program.Venezuela,
    Program.Panama,
    Program.Honduras,
    Program.Peru,
    Program.Ecuador,
    Program.Dominicana,
  ]),
};

@Directive({
  selector: '[appShowFeature]',
})
export class ShowFeatureDirective {
  private templateRef = inject(TemplateRef<any>);
  private viewContainerRef = inject(ViewContainerRef);
  private userDataService = inject(UserDataService);

  feature = input.required<Feature>({ alias: 'appShowFeature' });

  constructor() {
    effect(() => {
      const feature = this.feature();
      const userData = this.userDataService.userData();

      this.viewContainerRef.clear();

      if (!userData?.programId) {
        return;
      }

      const hasFeature = FEATURE_BY_PROGRAM[feature as Feature]?.has(
        userData.programId as Program,
      );

      if (hasFeature) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    });
  }
}
